import dynamic from "next/dynamic"

/** Warms the trip page chunk so opening the trip in the detail sheet doesn't wait on it */
export const loadTripSheetPage = () => import("./trip-sheet-page")

export const LazyTripSheetPage = dynamic(
  () => loadTripSheetPage().then((module) => module.TripSheetPage),
  { ssr: false }
)
